export default __webpack_public_path__ + "static/media/holy.06e1f969.png";